<template>
    <div class="customer-dashboard">
        <div class="IFrameLoader" id="my-superset-container">
            <br /><br /><br /><br />
            <h1 align="center">Dashboard is being loaded ...</h1>
        </div>
    </div>
</template>

<script>
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { services, APACHE_SUPERSET, getHeader } from '@/assets/js/config.js'
import axios from 'axios'
export default {
    methods: {
        getDashboardId() {
            let dashboardId = "d8ac7942-66e8-4556-b400-c7f111442e91";
            return dashboardId;
        },
        async guestToken() {
            const dashboard_id = this.getDashboardId();
            const apache_superset_token = localStorage.getItem(`superset_token_${dashboard_id}`) || '';

            try {
                const response = await axios.get(services.access_control + 'get_dashboard_token', {
                    params: {
                        dashboard_id,
                        apache_superset_token
                    }, headers: getHeader()
                })
                const token = response.data.token;
                if (token) {
                    localStorage.setItem(`superset_token_${dashboard_id}`, token);
                    return token;
                }
            } catch (error) {
                console.log(error);
            }
        }
    },
    created() {
        setTimeout(() => {
            embedDashboard({
                id: this.getDashboardId(), // given by the Superset embedding UI
                supersetDomain: APACHE_SUPERSET,
                mountPoint: document.getElementById("my-superset-container"), // any html element that can contain an iframe
                fetchGuestToken: () => this.guestToken(),
                dashboardUiConfig: {
                    hideTitle: true,
                    filters: {
                        expanded: false,
                        visible: false
                    },
                },
            });
        }, 2000);
    }
}
</script>